import { render, staticRenderFns } from "./ficheAction.vue?vue&type=template&id=3d170458"
import script from "./ficheAction.vue?vue&type=script&lang=js"
export * from "./ficheAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports